import React, { Component } from "react";
import AntdList, {ListProps} from "antd/lib/list";
import "antd/lib/list/style";

const { Item } = AntdList;
export default class List<T> extends Component<ListProps<T>> {
  static Item = Item;
  render() {
    return <AntdList {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/list/index.tsx